import curry from "./curry.js";

export default curry(function gt(a, b) {
  return a > b;
});